<script>
export default {
  props: {
    icon: {
      type: String,
      default: '$vuetify.icons.expand',
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statuses: [
        {
          id: 'active',
          text: 'Active',
        },
        {
          id: 'inactive',
          text: 'Inctive',
        },
        {
          id: 'both',
          text: 'Both',
        },
      ],
      order: [
        {
          id: 'parent',
          text: 'Is Explode Parent',
          checked: false,
        },
        {
          id: 'child',
          text: 'Is Explode Child',
          checked: false,
        },
      ],
      radioGroup: 'active',
      epic: null,
      description: null,
      field: null,
      hasRecord: false,
      expanded: this.isExpanded,
    }
  },
  computed: {
    panelClasses() {
      return {
        'ml-3': this.expanded,
        [this.$style.expandPanelExpanded]: this.expanded,
        [this.$style.expandPanelCollapsed]: !this.expanded,
      }
    },
  },
  methods: {
    togglePanel() {
      this.expanded = !this.expanded
      this.$emit('filterExpandChanged', this.expanded)
    },
  },
}
</script>

<template>
  <v-flex fluid :class="panelClasses">
    <!-- Toggle button -->
    <!-- TODO: Add toggle function -->
    <button :class="$style.expand" @click="togglePanel">
      <img src="/assets/icon-expand.svg" alt="Expand" />
    </button>

    <!-- Filter panel -->
    <!-- TODO: Add input functions -->
    <v-card
      :class="
        expanded ? $style.filterPanelExpanded : $style.filterPanelCollapsed
      "
    >
      <h4 class="ma-0">
        <img
          src="/assets/icon-expand.svg"
          :class="$style.collapse"
          alt="Collapse"
        />
        <strong>Filter</strong>
      </h4>

      <v-divider class="ma-0"></v-divider>

      <v-container class="px-3 py-0">
        <!-- Select -->
        <v-select label="Label" color="cyan" hide-details></v-select>

        <!-- Status radio -->
        <v-radio-group v-model="radioGroup" hide-details>
          <v-label>
            <strong>Status</strong>
          </v-label>
          <v-radio
            v-for="status in statuses"
            :key="status.id"
            :label="status.text"
            :value="status.id"
            color="cyan"
          ></v-radio>
        </v-radio-group>

        <!-- Epic input -->
        <v-text-field
          v-model="epic"
          label="Epic HC #"
          color="cyan"
          hide-details
        ></v-text-field>

        <!-- Description input -->
        <v-text-field
          v-model="description"
          label="Description"
          color="cyan"
        ></v-text-field>

        <!-- Explode checkboxes -->
        <v-label>
          <strong>Explodes</strong>
        </v-label>
        <div class="mb-3">
          <v-checkbox
            v-for="explosion in order"
            :key="explosion.id"
            v-model="explosion.checked"
            :label="explosion.text"
            :value="explosion.id"
            class="mt-0"
            color="cyan"
            hide-details
          />
        </div>

        <!-- Price info -->
        <v-label>
          <strong>Price Information</strong>
        </v-label>
        <v-layout wrap>
          <!-- Price -->
          <v-flex xs6>
            <v-select label="Price" color="cyan" hide-details></v-select>
          </v-flex>

          <!-- Field -->
          <v-flex xs6>
            <v-text-field
              v-model="field"
              label="Field"
              color="cyan"
            ></v-text-field>
          </v-flex>

          <!-- From date -->
          <v-flex xs6>
            <v-select label="Effect Date" color="cyan"></v-select>
          </v-flex>

          <!-- To date -->
          <v-flex xs6>
            <v-select color="cyan"></v-select>
          </v-flex>
        </v-layout>

        <!-- Historical record check -->
        <v-checkbox
          :label="'Historical Record of Changes (Has CDM-R History)'"
          :value="hasRecord"
          class="mt-0"
          color="cyan"
        />

        <!-- Form actions -->
        <v-layout space-between>
          <v-btn :class="$style.action" small depressed outline>Reset</v-btn>
          <v-btn :class="$style.action" small depressed dark color="cyan"
            >Apply</v-btn
          >
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<style lang="scss" module>
@import '@design';

.expandPanelExpanded {
  max-width: 25%;
}

.expandPanelCollapsed {
  max-width: 40px;
}

.expand {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
  background: white;
  border: 1px solid lightgray;
}

.collapse {
  margin: 0 8px 0 13px;
  vertical-align: initial;
  transform: rotate(180deg);
}

.action {
  flex: 1;
  margin: 0 5px 20px;
}

.filterPanelExpanded {
  display: block;
}

.filterPanelCollapsed {
  display: none;
}
</style>
